import React from "react";

/**
 * Iter-258 §10: Legacy Bike details card. Rendered on bike-family
 * detail pages ONLY (gate on `parent_category_slug === "bikes"` or the
 * leaf slug as a fallback). Never for cars, per the founder mandate.
 *
 * Data source: top-level Make/Model/Year mirrors + a few high-signal
 * bike attributes (Engine Size, Kilometres, Colour, Registration Exp,
 * WoF Exp). Extra attributes still render in the main DetailsRow grid;
 * this card exists so bike buyers see the four-fact "spec chip" the
 * legacy site had.
 */
const BIKE_ATTR_KEYS = [
  "Engine Size",
  "Kilometres",
  "Kms",
  "Colour",
  "Color",
  "Fuel Type",
  "Transmission",
  "Registration Exp",
  "WoF Exp",
];

export default function BikeDetailsCard({ listing }) {
  const a = listing.attributes || {};
  const rows = [
    ["Make", listing.make || a.Make],
    ["Model", listing.model || a.Model],
    ["Year", listing.year || a.Year],
  ].filter(([, v]) => v);
  BIKE_ATTR_KEYS.forEach((k) => {
    if (a[k] && !rows.some(([label]) => label === k)) {
      rows.push([k, a[k]]);
    }
  });
  if (!rows.length) return null;
  return (
    <div
      data-testid="ad-bike-details"
      className="mt-4 rounded-2xl bg-white border border-soft p-5"
    >
      <h2 className="font-display text-lg font-bold text-slate-800 mb-3">
        Bike details
      </h2>
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {rows.map(([k, v]) => (
          <div
            key={k}
            className="flex items-baseline gap-2 border-b border-dashed border-slate-100 py-1"
            data-testid={`bike-details-row-${k.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
          >
            <dt className="text-slate-500 shrink-0">{k}</dt>
            <dd className="text-slate-800 font-medium ml-auto text-right break-words">
              {v}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
